import axios from "axios";

const baseURL = process.env.REACT_APP_NODEJS_SERVER_URL || "";

const isInternalApiRequest = (url = "") => {
  const target = String(url || "").trim();
  if (!target) return true;
  if (/^https?:\/\//i.test(target)) {
    return baseURL ? target.startsWith(baseURL) : false;
  }
  return true;
};

const attachAccessToken = (client) => {
  client.interceptors.request.use((config) => {
    if (!isInternalApiRequest(config?.url)) {
      return config;
    }

    const accessToken =
      typeof window !== "undefined" && window.localStorage
        ? window.localStorage.getItem("accessToken")
        : null;

    if (!accessToken) {
      return config;
    }

    const nextHeaders = {
      ...(config.headers || {}),
    };

    if (!nextHeaders.accessToken) {
      nextHeaders.accessToken = accessToken;
    }

    config.headers = nextHeaders;
    return config;
  });

  return client;
};

export const createAuthenticatedApiClient = (config = {}) =>
  attachAccessToken(
    axios.create({
      baseURL,
      ...config,
    })
  );

const apiClient = createAuthenticatedApiClient();

export default apiClient;
